export class AttendingStatus {

    // private to disallow creating other instances of this type
    private constructor(private readonly key: string, public readonly value: any, public readonly icon: string) {
    }

    getKey() {
        return this.key;
    }

    getIcon() {
        return this.icon;
    }

    getValue() {
        return this.value;
    }

    static retrieveValueByKey(key: string): string {
        switch (key) {
            case this.ATTENDING.getKey():
                return this.ATTENDING.getValue();
            case this.NOT_RESPONDED.getKey():
                return this.NOT_RESPONDED.getValue();
            case this.NOT_SURE_YET.getKey():
                return this.NOT_SURE_YET.getValue();
            case this.NOT_ATTENDING.getKey():
                return this.NOT_ATTENDING.getValue();
            default:
                return this.EMPTY.getValue();
        }
    }

    static retrieveKeyByValue(value: string): string {
        switch (value) {
            case this.ATTENDING.getValue():
                return this.ATTENDING.getKey();
            case this.NOT_ATTENDING.getValue():
                return this.NOT_ATTENDING.getKey();
            case this.NOT_SURE_YET.getValue():
                return this.NOT_SURE_YET.getKey();
            case this.NOT_RESPONDED.getValue():
                return this.NOT_RESPONDED.getKey();
            default:
                return this.EMPTY.getKey();
        }
    }

    static retrieveIconByValue(value: string): string {
        switch (value) {
            case this.ATTENDING.getValue():
                return this.ATTENDING.getIcon();
            case this.NOT_ATTENDING.getValue():
                return this.NOT_ATTENDING.getIcon();
            case this.NOT_RESPONDED.getValue():
                return this.NOT_RESPONDED.getIcon();
            case this.NOT_SURE_YET.getValue():
                return this.NOT_SURE_YET.getIcon();
            default:
                return this.EMPTY.getIcon();
        }
    }

    static readonly NOT_RESPONDED = new AttendingStatus('NOT_RESPONDED', 'Pas répondu', 'bi-question-square');
    static readonly ATTENDING = new AttendingStatus('ATTENDING', 'Présent', 'bi-check-square');
    static readonly NOT_ATTENDING = new AttendingStatus('NOT_ATTENDING', 'Absent', 'bi-x-square');
    static readonly NOT_SURE_YET = new AttendingStatus('NOT_SURE_YET', 'Ne sais pas encore', 'bi-exclamation-square');
    static readonly EMPTY = new AttendingStatus('', '-----', '');
}
